import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useTypedSelector } from "../../hooks";

const PrivateRoute = ({ children, ...props }) => {
    const stateLogin = useTypedSelector(state => state.loginreducer);

    let usuarioLogado = stateLogin.Login !== "";

    return (
        <Route {...props}>
            {usuarioLogado ? children : <Redirect to="/" />}
        </Route>
    );
};

export default PrivateRoute;
